import { GeneralService } from './../../../services/general.service';
import { FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';


export class FormHumidityBuild {

    public buildForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): FormGroup {
        this.buildFormI(form, arrForm[0], generalService);
        return form;
    }

    private buildFormI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {

        form.get('id').setValue(formCard.get('id')?.value);
        form.get('hibrido').setValue(formCard.get('hibrido')?.value);
        form.get('safra').setValue(formCard.get('safra')?.value);
        form.get('padrao_percentil').setValue(formCard.get('padrao_percentil')?.value);
        form.get('umidade_maxima').setValue(formCard.get('umidade_maxima')?.value);

        return form;
    }


    public updateForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): void {
        this.updateFormI(form, arrForm[0], generalService);
    }

    private updateFormI(data: any, formCard: FormGroup, generalService: GeneralService): void {
        
        formCard.get('id').setValue(data.id);
        formCard.get('hibrido').setValue(data.hibrido);
        formCard.get('safra').setValue(data.safra);
        formCard.get('padrao_percentil').setValue(data.padrao_percentil);
        formCard.get('umidade_maxima').setValue(data.umidade_maxima);
        
    }

 
}
